import { SliderBannerStatus } from './slider-banner-status';
import { Serializable } from '../../../core/models/serializable';
export class SliderBannerRequestFilterModel
  implements Serializable<SliderBannerRequestFilterModel>
{
  fromObject(object: any): SliderBannerRequestFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      CustomerName: this.customerName,
      StatusIds: this.statusIds,
    };

    return result;
  }

  public customerName: string;
  public statusIds: SliderBannerStatus[];

  constructor() {
    this.statusIds = [];
  }
}
